import { useContext } from "react";
import { Context } from "../../../utils/main-context/MainContext";

import { useParams } from "react-router-dom";

import "./card-presentation.scss";

import projects from "../../../database/projects.json";

import shop1 from "../../../assets/images/maybach-shop/1.png";
import shop2 from "../../../assets/images/maybach-shop/2.png";
import shop3 from "../../../assets/images/maybach-shop/3.png";
import shop4 from "../../../assets/images/maybach-shop/4.png";

import dash1 from "../../../assets/images/maybach-dash/1.png";
import dash2 from "../../../assets/images/maybach-dash/2.png";
import dash3 from "../../../assets/images/maybach-dash/3.png";
import dash4 from "../../../assets/images/maybach-dash/4.png";

import gi1 from "../../../assets/images/gi-group/1.png";
import gi2 from "../../../assets/images/gi-group/2.png";
import gi3 from "../../../assets/images/gi-group/3.png";
import gi4 from "../../../assets/images/gi-group/4.png";

import back1 from "../../../assets/images/project-backend/1.png";
import back2 from "../../../assets/images/project-backend/2.png";

const CardPresentation = () => {
  const { workPreActive } = useContext(Context);

  const params = useParams();

  const project = projects.projects.find((data) => data.id === params?.id);

  return (
    <section
      className={
        workPreActive ? "card-presentation active" : "card-presentation"
      }
    >
      <div className="container">
        {params.id === "1" && (
          <>
            <img src={shop1} alt={project.name} />
            <img src={shop2} alt={project.name} />
            <img src={shop3} alt={project.name} />
            <img src={shop4} alt={project.name} />
          </>
        )}

        {params.id === "2" && (
          <>
            <img src={dash1} alt={project.name} />
            <img src={dash2} alt={project.name} />
            <img src={dash3} alt={project.name} />
            <img src={dash4} alt={project.name} />
          </>
        )}

        {params.id === "3" && (
          <>
            <img src={gi1} alt={project.name} />
            <img src={gi2} alt={project.name} />
            <img src={gi3} alt={project.name} />
            <img src={gi4} alt={project.name} />
          </>
        )}

        {params.id === "4" && (
          <>
            <img src={back1} alt={project.name} />
            <img src={back2} alt={project.name} />
          </>
        )}
      </div>
    </section>
  );
};

export default CardPresentation;
